module.exports = __webpack_public_path__ + "img/FGr_WP_B.b7533b2e.svg";